import {createApp} from 'vue';
import * as components from './components';

document.querySelectorAll('[data-vue-component]').forEach(element => {
    const component = components[element.dataset.vueComponent];
    if (!component) {
        return;
    }
    const props = element.dataset.vueProps ? JSON.parse(element.dataset.vueProps) : {};
    const app = createApp(component, props);
    app.mount(element);
});
